import {openResourceModal} from '../../core/modalCommand';
import {
	FLOOR_PLAN_CONFIGURE_MODAL_EVENT,
	FLOOR_PLAN_CREATE_MODAL_EVENT,
	FLOOR_PLAN_DELETE_MODAL_EVENT,
	FLOOR_PLAN_PREVIEW_MODAL_EVENT,
} from './events';

/**
 * Open the Add Floor Plan form.
 * @param {object} command modal command
 * @param {object} envelope command envelope
 * @return {Promise<object>} completion
 */
export function openFloorPlanCreateModal(command, envelope) {
	return openResourceModal(FLOOR_PLAN_CREATE_MODAL_EVENT, command, envelope);
}

/**
 * Open a floor plan in the editor, where devices are placed on the drawing.
 *
 * Open-only ends here: the agent opens the editor and the person drags the
 * Access Points and Switches onto the plan themselves.
 *
 * @param {object} command modal command
 * @param {object} envelope command envelope
 * @return {Promise<object>} completion
 */
export function openFloorPlanConfigureModal(command, envelope) {
	return openResourceModal(
		FLOOR_PLAN_CONFIGURE_MODAL_EVENT, command, envelope,
	);
}

/**
 * Open a floor plan's preview.
 * @param {object} command modal command
 * @param {object} envelope command envelope
 * @return {Promise<object>} completion
 */
export function openFloorPlanPreviewModal(command, envelope) {
	return openResourceModal(FLOOR_PLAN_PREVIEW_MODAL_EVENT, command, envelope);
}

/**
 * Open a floor plan's Delete confirmation.
 * @param {object} command modal command
 * @param {object} envelope command envelope
 * @return {Promise<object>} completion
 */
export function openFloorPlanDeleteModal(command, envelope) {
	return openResourceModal(FLOOR_PLAN_DELETE_MODAL_EVENT, command, envelope);
}
